export default function Process() {
  const steps = [
    { n: '01', title: 'Site Assessment', copy: 'A specialist evaluates your roof, shading, orientation and historical energy use — remotely and on-site.' },
    { n: '02', title: 'System Design', copy: 'Custom-engineered layout with production estimates, financing model and permitting handled end-to-end.' },
    { n: '03', title: 'Installation', copy: 'Certified crews install your system, typically in one to three days, with minimal disruption to your home or operations.' },
    { n: '04', title: 'Activation', copy: 'Grid interconnection, monitoring setup and a walk-through — your system starts producing clean energy from day one.' },
  ];

  return (
    <section id="process" className="py-[64px] md:py-[120px] bg-white">
      <div className="container-x">
        <div className="grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-6">
            <p className="text-xs font-medium text-solar-green tracking-wider uppercase">Installation</p>
            <h2 className="display-font mt-4 text-[34px] md:text-[48px] font-semibold leading-[1.05] text-solar-ink">
              Four steps.<br/>Nothing more.
            </h2>
            <p className="mt-6 text-solar-muted text-[15px] md:text-base leading-relaxed max-w-[480px]">
              A calm, well-managed process — from the first roof measurement to the moment your system starts producing.
            </p>
          </div>

          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <div className="aspect-[4/3] md:aspect-[3/4] w-full md:max-w-[440px] md:ml-auto overflow-hidden rounded-2xl bg-solar-divider">
              <img
                src="https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20cleanly%20installed%20black%20solar%20panels%20on%20a%20modern%20architectural%20roof%20with%20warm%20natural%20light%2C%20precise%20geometric%20lines%2C%20soft%20shadows%2C%20clean%20mounting%20hardware%2C%20editorial%20architecture%20photography%2C%20minimal%20quiet%20composition%2C%20cool%20neutral%20tones&width=700&height=933&seq=process-img-01&orientation=portrait"
                alt="Precise rooftop solar installation detail"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="mt-5 md:max-w-[440px] md:ml-auto flex items-center justify-between gap-4">
              <div>
                <p className="text-[11px] font-medium tracking-[0.18em] uppercase text-solar-muted">Typical installation</p>
                <p className="display-font mt-1 text-[20px] md:text-[22px] font-semibold text-solar-ink leading-tight">1–3 days</p>
              </div>
              <p className="text-[12px] tracking-wider uppercase text-solar-muted text-right leading-relaxed">
                Design → Permit<br/>Install → Activate
              </p>
            </div>
          </div>
        </div>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6">
          {steps.map((s, i) => (
            <div key={s.n} className="relative pt-6 border-t border-solar-ink/90">
              <span className="text-xs font-semibold text-solar-ink tracking-wider">{s.n}</span>
              <h3 className="display-font mt-4 text-[20px] md:text-[22px] font-semibold text-solar-ink leading-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-solar-muted text-[14px] leading-relaxed">{s.copy}</p>
              {i < steps.length - 1 && (
                <i className="hidden md:block ri-arrow-right-line absolute -right-2 top-6 text-solar-divider"></i>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}